module.exports = __webpack_public_path__ + "static/media/icon-happy.cd14a3ec.svg";